import React, { useState, useEffect } from 'react';
// Added Grid hook
import { Card, List, Avatar, Button, Tag, Typography, message, Empty, Grid, Space } from 'antd';
import { EyeOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';

const { Text } = Typography;
const { useBreakpoint } = Grid; // RESPONSIVE CHANGE

const MentorMentees = () => {
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const screens = useBreakpoint(); // RESPONSIVE CHANGE

    const fetchMatches = async () => {
        setLoading(true);
        try {
            const res = await api.get('/mentor/matches');
            setMatches(res.data);
        } catch (e) {
            message.error('Failed to load mentees');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchMatches(); }, []);

    return (
        // RESPONSIVE CHANGE: Reduce padding for the main card container on mobile
        <div style={{ padding: screens.xs ? '8px' : '0' }}>
            <Card title="My Mentees" loading={loading} bodyStyle={{ padding: screens.xs ? '12px' : '24px' }}>
                <List
                    // RESPONSIVE CHANGE: Switch to vertical layout for mobile to prevent squashing
                    itemLayout={screens.xs ? "vertical" : "horizontal"}
                    dataSource={matches}
                    renderItem={(item) => (
                        <List.Item
                            // RESPONSIVE CHANGE: Hide actions on the right for mobile, we'll put them in the body
                            actions={!screens.xs ? [
                                <Button 
                                    type="primary" 
                                    icon={<EyeOutlined />} 
                                    onClick={() => navigate(`/mentor/track/${item.id}`)}
                                    style={{ backgroundColor: '#FE1F08', borderColor: '#FE1F08' }}
                                >
                                    Track Progress
                                </Button>
                            ] : []}
                        >
                            <List.Item.Meta
                                avatar={<Avatar size={screens.xs ? "default" : "large"} icon={<UserOutlined />} style={{ backgroundColor: '#FE1F08' }} />}
                                title={<Text strong>{item.mentee.title} {item.mentee.name}</Text>}
                                description={
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <Space wrap>
                                            <Tag color="blue">{item.mentee.profession}</Tag>
                                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                                {screens.xs ? '' : 'Paired: '}{new Date(item.start_date).toLocaleDateString()}
                                            </Text>
                                        </Space>
                                        
                                        {/* Bio text - limit visibility on mobile to keep list clean */}
                                        <Text 
                                            type="secondary" 
                                            ellipsis={screens.xs ? { rows: 2 } : false}
                                            style={{ marginTop: 4 }}
                                        >
                                            {item.mentee.bio || "No bio provided."}
                                        </Text>

                                        {/* RESPONSIVE CHANGE: Show button here only on mobile */}
                                        {screens.xs && (
                                            <Button 
                                                type="primary" 
                                                block
                                                icon={<EyeOutlined />} 
                                                onClick={() => navigate(`/mentor/track/${item.id}`)}
                                                style={{ marginTop: 12, backgroundColor: '#FE1F08', borderColor: '#FE1F08' }}
                                            >
                                                Track Progress
                                            </Button>
                                        )}
                                    </div>
                                }
                            />
                        </List.Item>
                    )}
                    locale={{ emptyText: <Empty description="No mentees paired yet." /> }}
                />
            </Card>
        </div>
    );
};

export default MentorMentees;